import clsx from 'clsx'
import React from 'react'
import { useSelector } from 'react-redux'

import { DashboardLayout, Icon, Modal } from '../../components'
import { isDesktop } from '../../utils'
import AllConversions from './AllConversions'
import Chart from './Chart'

import './Watchlist.scss'

const Watchlist = () => {
   const { isDarkTheme } = useSelector(state => state.theme)
   const { watchlist } = useSelector(state => state.conversions)

   const [selectedConversion, setSelectedConversion] = React.useState({
      from: {
         name: 'Binance Coin',
         unit: 'BNB',
         change: 20.13,
         image: 'https://via.placeholder.com/32',
      },
      to: {
         name: 'TetherUS',
         unit: 'USDT',
         change: 0.03,
         image: 'https://via.placeholder.com/32',
      },
      value: 604.34,
   })
   const [isModalVisible, setIsModalVisible] = React.useState(false)

   if (isDesktop()) {
      return (
         <DashboardLayout>
            <div
               className={clsx(
                  'DesktopWatchlist',
                  isDarkTheme && 'DesktopWatchlist--dark'
               )}
            >
               <div className="DesktopWatchlist__header">
                  <div className="DesktopWatchlist__header-content">
                     <h1 className="DesktopWatchlist__header-content-heading">
                        Watchlist
                     </h1>
                     <div className="DesktopWatchlist__actions">
                        <Icon
                           name="settings"
                           className="DesktopWatchlist__actions-icon"
                        />
                        <Icon
                           className="Watchlist__header-plus"
                           name="plus"
                           onClick={() => setIsModalVisible(true)}
                        />
                     </div>
                  </div>
               </div>
               <div className="DesktopWatchlist__grid">
                  <div className="DesktopWatchlist__chart-container">
                     {selectedConversion && (
                        <Chart conversion={selectedConversion} />
                     )}
                  </div>
                  <div className="DesktopWatchlist__list">
                     {watchlist.map((conversion, index) => (
                        <div
                           className="DesktopWatchlist__list-card"
                           key={index}
                           onClick={() => setSelectedConversion(conversion)}
                        >
                           <div className="DesktopWatchlist__list-card-images">
                              <img
                                 className="DesktopWatchlist__list-card-images-to"
                                 src={conversion.to.image}
                                 alt={conversion.to.name}
                              />
                              <img
                                 className="DesktopWatchlist__list-card-images-from"
                                 src={conversion.from.image}
                                 alt={conversion.from.name}
                              />
                           </div>
                           <div className="DesktopWatchlist__list-card-content">
                              <div className="DesktopWatchlist__list-card-content-top">
                                 <h3 className="DesktopWatchlist__list-card-content-top-unit">
                                    {conversion.from.unit}
                                    {conversion.to.unit}
                                 </h3>
                                 <h3 className="DesktopWatchlist__list-card-content-top-value">
                                    {conversion.value}
                                 </h3>
                              </div>
                              <div className="DesktopWatchlist__list-card-content-bottom">
                                 <span className="DesktopWatchlist__list-card-content-bottom-name">
                                    {conversion.from.name} /{' '}
                                    {conversion.to.name}
                                 </span>
                                 <span>
                                    <span
                                       className={clsx(
                                          'DesktopWatchlist__list-card-content-bottom-change',
                                          conversion.from.change < 0 &&
                                             'DesktopWatchlist__list-card-content-bottom-change--negative'
                                       )}
                                    >
                                       {conversion.from.change > 0 && '+'}{' '}
                                       {conversion.from.change}%
                                    </span>
                                    <span
                                       className={clsx(
                                          'DesktopWatchlist__list-card-content-bottom-change',
                                          conversion.to.change < 0 &&
                                             'DesktopWatchlist__list-card-content-bottom-change--negative'
                                       )}
                                    >
                                       {conversion.to.change > 0 && '+'}{' '}
                                       {conversion.to.change}%
                                    </span>
                                 </span>
                              </div>
                           </div>
                        </div>
                     ))}
                  </div>
               </div>
            </div>

            <Modal
               heading="Add Symbol"
               isOpen={isModalVisible}
               isDarkTheme={isDarkTheme}
               close={() => setIsModalVisible(false)}
            >
               <AllConversions />
            </Modal>
         </DashboardLayout>
      )
   }

   return (
      <DashboardLayout
         className={clsx('Watchlist', isDarkTheme && 'Watchlist--dark')}
      >
         <header className="Watchlist__header">
            <span className="Watchlist__header-title">Watchlist</span>
            <Icon
               className="Watchlist__header-plus"
               name="plus"
               onClick={() => setIsModalVisible(true)}
            />
         </header>
         <div className="Watchlist__list">
            {watchlist.map(conversion => (
               <div className="Watchlist__list-card">
                  <div className="Watchlist__list-card-images">
                     <img
                        className="Watchlist__list-card-images-to"
                        src={conversion.to.image}
                        alt={conversion.to.name}
                     />
                     <img
                        className="Watchlist__list-card-images-from"
                        src={conversion.from.image}
                        alt={conversion.from.name}
                     />
                  </div>
                  <div className="Watchlist__list-card-content">
                     <div className="Watchlist__list-card-content-top">
                        <h3 className="Watchlist__list-card-content-top-unit">
                           {conversion.from.unit}
                           {conversion.to.unit}
                        </h3>
                        <h3 className="Watchlist__list-card-content-top-value">
                           {conversion.value}
                        </h3>
                     </div>
                     <div className="Watchlist__list-card-content-bottom">
                        <span className="Watchlist__list-card-content-bottom-name">
                           {conversion.from.name} / {conversion.to.name}
                        </span>
                        <span>
                           <span
                              className={clsx(
                                 'Watchlist__list-card-content-bottom-change',
                                 conversion.from.change < 0 &&
                                    'Watchlist__list-card-content-bottom-change--negative'
                              )}
                           >
                              {conversion.from.change > 0 && '+'}{' '}
                              {conversion.from.change}%
                           </span>
                           <span
                              className={clsx(
                                 'Watchlist__list-card-content-bottom-change',
                                 conversion.to.change < 0 &&
                                    'Watchlist__list-card-content-bottom-change--negative'
                              )}
                           >
                              {conversion.to.change > 0 && '+'}{' '}
                              {conversion.to.change}%
                           </span>
                        </span>
                     </div>
                  </div>
               </div>
            ))}
         </div>

         <Modal
            heading="Add Symbol"
            isOpen={isModalVisible}
            isDarkTheme={isDarkTheme}
            close={() => setIsModalVisible(false)}
         >
            <AllConversions />
         </Modal>
      </DashboardLayout>
   )
}

export default Watchlist
